import { forwardRef, type Ref, type ChangeEvent } from "react";
import { type IInput } from "./types";
import {
  InputWrapper,
  StyledLabel,
  StyledInput,
  ErrorMessage,
  IconWrapper,
} from "./style";
import SearchIcon from "../../assets/icons/SearchIcon";

const Input = forwardRef(
  (
    {
      theme,
      label,
      placeholder,
      defaultValue,
      name,
      onChange,
      required,
      type,
      variant,
      message,
      onKeyDownCapture,
      icon = false,
      register,
      mask,
      value,
    }: IInput & { mask?: (value: string) => string },
    ref: Ref<HTMLInputElement>,
  ) => {
    theme = theme || "modern";
    variant = variant || "unabled";

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      // spread de elemento DOM perde name/type/checked (accessors do prototype);
      // aplica a máscara no próprio input e repassa o evento original intacto
      if (mask) {
        e.target.value = mask(e.target.value);
      }
      onChange?.(e);
    };

    return (
      <InputWrapper $theme={theme} $variant={variant} $message={message}>
        {label && <StyledLabel>{label}</StyledLabel>}
        <div style={{ position: "relative" }}>
          {icon && (
            <IconWrapper>
              <SearchIcon />
            </IconWrapper>
          )}
          <StyledInput
            ref={ref}
            defaultValue={defaultValue}
            placeholder={placeholder}
            name={name}
            value={value}
            {...register}
            onChange={handleChange}
            onKeyDownCapture={onKeyDownCapture}
            required={required}
            type={type}
            $hasIcon={icon}
            autoComplete="off"
          />
        </div>
        {message && <ErrorMessage>{message}</ErrorMessage>}
      </InputWrapper>
    );
  },
);

export default Input;
